





















import Vue from 'vue'
import { Col, Row, Input } from 'element-ui'
import { Version } from '@/store/types'
import './NewVersion.scss'

export default Vue.extend({
  name: 'NewVersion',
  data: () => ({
    columnsize: [6, 18],
    newVersion: {}
  }),
  props: {
    value: {
      type: Object as () => Version,
      required: true
    }
  },
  watch: {
    value: {
      handler (val: Version) {
        this.newVersion = val
      },
      immediate: true
    }
  },
  components: {
    'el-col': Col,
    'el-row': Row,
    'el-input': Input,
  }
})
